import i18n from 'i18next';
import i18next from 'i18next';
import esFlag from 'src/icons/esFlag';
import ukFlag from 'src/icons/ukFlag';
import ptFlag from 'src/icons/ptFlag';
import { User } from 'src/types/user';
import { Languages } from 'src/types/translations';
import {
  defaultTranslations,
  defaultTranslationsWithNoInformation,
  nameSpacesWithCustomTitles,
  nameSpacesWithNoInformationTitles,
  translationsWithNoInformation,
} from 'src/constants/translations';

const { EN, ES, PT } = Languages;

export const languageOptions = {
  es: {
    icon: esFlag,
    label: 'DASHBOARD:LANGUAGE_ES',
  },
  en: {
    icon: ukFlag,
    label: 'DASHBOARD:LANGUAGE_EN',
  },
  pt: {
    icon: ptFlag,
    label: 'DASHBOARD:LANGUAGE_PT',
  },
};

export const getCurrentLanguageElement = () => languageOptions[i18n.language];

export const setCurrentLanguage = (user: User) => {
  let languageSymbol = user?.language;
  if (!languageSymbol) {
    languageSymbol = getNavigatorLanguage();
  }

  if (languageSymbol === ES || languageSymbol === EN || languageSymbol === PT) {
    i18n.changeLanguage(languageSymbol);
  }
};

export const getNavigatorLanguage = (): string => (
  navigator.language.substring(0, 2)
);

export const restoreTitleWithNoInfo = () => {
  for (const [lng, translate] of Object.entries(defaultTranslationsWithNoInformation)) {
    nameSpacesWithNoInformationTitles.forEach(nameSpace =>
      i18next.addResources(lng, nameSpace, { [`NO_${nameSpace}`]: translate[`NO_${nameSpace}`] }));
  }
};

export const changeTitleModule = (modulesName, nameSpace, restoreNsWithNoInfo = false) => {
  for (const [lng, translate] of Object.entries(modulesName)) {
    if (!translate.hasOwnProperty(nameSpace)) {
      continue;
    }
    i18next.addResources(lng, nameSpace, { [nameSpace]: translate[nameSpace] });
    if (!restoreNsWithNoInfo) {
      const translateWithNoInfo = translationsWithNoInformation(nameSpace, translate[nameSpace]);
      if (!!translateWithNoInfo) {
        i18next.addResources(lng, nameSpace, { [`NO_${nameSpace}`]: translateWithNoInfo[lng][`NO_${nameSpace}`] });
      }
    }
    else {
      restoreTitleWithNoInfo();
    }
  }
};

export const restoreNameSpaces = () =>
  nameSpacesWithCustomTitles.forEach(
    nameSpace => changeTitleModule(defaultTranslations, nameSpace, true));
